export class Protocol {
    static type_setEntityId: string = "0"
    static type_destroyEntityId: string = "1"
    static type_ping: string = "2"
    static type_struckEntityId: string = "3"
    static type_worldState: string = "4"
    static type_entityDisconnected: string = "5"
    static type_dropAction: string = "6"
    static type_screenMessage: string = "7"
    static type_detonate: string = "8"
    static type_chatMessage: string = "9"
    static type_resetAction: string = "10"
    static type_boostAction: string = "11"
    static type_aStarResult: string = "12"
    static type_aStarRequest: string = "14"
    static type_attack: string = "15"
    static type_killed: string = "16"
    static type_respawned: string = "17"
    static type_orientation: string = "18"
    static type_fadeInOut: string = "19"
    static type_fireWeapon: string = "20"
    static type_activateInventoryItem: string = "21"
    static type_entityEmp: string = "22"
    static type_hideRoomName: string = "23"
    static type_sendUpdateLocation: string = "24"
    static type_createLocalEntity: string = "25"
    static type_soundEffect: string = "26"
    static type_destroyLocalEntity: string = "27"
    static type_sendAnimateLocalEntityCollection: string = "28"
    static type_activateAbility: string = "29"
    static type_animateAbility: string = "30"
    static type_updateName: string = "31"
    static type_upgradeGuest: string = "32"
    static type_login: string = "33"
    static type_logActivity: string = "34"
    static type_playerEvent: string = "35"
    static type_showStatUpgradeUI: string = "36"
    static type_entityClicked: string = "37"
    static type_inventoryAction: string = "38"
    static type_requestEntityDetail: string = "39"
    static type_requestItemPickup: string = "40"
    static type_saveAppearance: string = "41"
    static type_mapDelta: string = "42"
    static type_entityTileEffect: string = "43"
    static type_dayPhase: string = "44"
    static type_startSession: string = "45"
    static type_updatePlayerEntityId: string = "46"
    static type_updateSquadState: string = "47"
    static type_requestEntityInteractions: string = "48"
    static type_updateEntityInteractions: string = "49"
    static type_updateEntityPointerIcon: string = "50"
    static type_buildCharacter: string = "51"
    static type_finalizeCharacter: string = "52"
    static type_itemPickedUp: string = "53"
    static type_showTutorial: string = "54"
    static type_updatePlayerBiomeColorMap: string = "55"
    static type_pulseInventoryItem: string = "56"
    static type_fragmentAnimation: string = "57"
    static type_entityFeedback: string = "58"
    static type_onDialogClose: string = "59"
    static type_sendVisibility: string = "60"
    static type_sendTeleported: string = "61"
    static type_locationIconEffect: string = "62"
    static type_updateAudio: string = "63"
    static type_submitFeedback: string = "64"
    static type_sendPleaseWait: string = "65"
    static type_requestPlayerLocations: string = "66"
    static type_activateWorldPoint: string = "67"
    static type_commitWorldEdits: string = "68"
    static type_redrawClient: string = "69"
    static type_getBuildingTilePreview: string = "70"
    static type_sendBuildingTilePreview: string = "71"
    static type_requestVisibility: string = "72"
    static type_builderAction: string = "73"
    static type_requestWorldMap: string = "74"
    static type_sendWorldMap: string = "75"
    static type_requestDropActiveItem: string = "76"
    static type_worldMapClicked: string = "77"
    static type_removeLocationIcon: string = "78"
    static type_addLocationIcon: string = "79"
    static type_startAttack: string = "80"
    static type_entityTileStrikeAt: string = "81"
    static type_attackComplete: string = "82"
    static type_updateActivation: string = "83"
    // Cosmetic: make an entity play its attack (swing) animation with no damage/gameplay effect
    // (e.g. a player swinging while placing a building tile).
    static type_playAttackAnimation: string = "84"
    // Configure client-side faction tracking (offscreen edge arrows toward faction members).
    static type_factionTracking: string = "85"
    // Server-initiated: open the command wheel bound to a specific NPC, locked to its role
    // (forager/defender). Payload: { entityId, role }.
    static type_openCommandWheel: string = "86"
    // Per-room roster of notable NPCs (ember defenders/foragers/lord) for a clickable HUD
    // strip. Only emitted for rooms that opt in (room.emberRosterEnabled). Payload: { roster }.
    static type_updateEmberRoster: string = "87"
    // Client-initiated: follow-cam focus. Promotes the given entity + its neighbors to the
    // detailed, every-tick sync tier so a picture-in-picture view can watch it in real time.
    // Payload: { entityId } to focus, or { entityId: null } to clear.
    static type_setFocusEntity: string = "88"
    // Server-initiated one-shot cosmetic: play a green "sparkle halo" over an entity (e.g.
    // when a campfire is refreshed with wood). Payload: { entityId }.
    static type_entitySparkle: string = "89"
    // Server-initiated: open the recruit ROLE PICKER over a specific NPC, so the player can assign
    // it a role (forager/defender). Payload: { entityId, currentRole? }.
    //
    // `currentRole` is what turns the same widget into a CHANGE: sent only by an already-hired
    // member's "Change Role" order, it names the job that member holds now, and the picker then
    // offers just the other one (see lib/role_change.js). Absent at a hire, where neither job is
    // held yet and both are on offer.
    static type_openRolePicker: string = "90"
    // Server-initiated: the player's ember run is over -- show the centered end-of-run summary
    // panel (time survived, waves, kills, camp work) with its "Try again" button.
    // Payload: { summary: EmberRunSummary }.
    static type_showRunSummary: string = "91"
    // Server-initiated: put up (or take down) the first-run ember tutorial invitation -- a small
    // stage-anchored bar with "show me"/"skip" and a visible countdown that resolves to "show me".
    // Payload: { prompt: EmberTutorialPrompt } to show, { prompt: null } to dismiss.
    static type_showTutorialPrompt: string = "92"
    // Per-room positions for the ember minimap: every camp member and every wave attacker in the
    // room, plus the room's extent. Only emitted for rooms that opt in (room.emberRosterEnabled).
    // Payload: { minimap: EmberMinimapState }.
    static type_updateEmberMinimap: string = "93"
    // Who ELSE is logged into the server right now, and which wave their camp is on. Sent to each
    // player in an ember room by the EMBER_PLAYERS campaign; the list a player receives never
    // contains themselves. Payload: { players: EmberPlayerEntry[] }.
    static type_updateEmberPlayers: string = "94"
    // Client-initiated: invite another online player into this player's ember camp. The server
    // (EMBER_PLAYERS) decides whether the invite is allowed and where the guest lands.
    // Payload: { entityId }.
    static type_inviteEmberPlayer: string = "95"
    // Server-initiated: put up (or take down) the invitation prompt on the INVITED player -- who is
    // asking, and how long they have to answer. Reaches that player wherever they are, camp or not.
    // Payload: { invite: EmberInvite } to show, { invite: null } to dismiss.
    static type_updateEmberInvite: string = "96"
    // Client-initiated: the invited player's answer. Only an accepted one moves anybody.
    // Payload: { entityId (who invited them), accepted }.
    static type_answerEmberInvite: string = "97"
    // Everything a room says about its own atmosphere, in one payload (RoomAmbience): the windblown
    // leaves, the night fog, the butterflies. Sent on EVERY room entry, including an empty one, so a
    // camp's weather cannot follow the player out into a room that has none of it. Payload:
    // { ambience }.
    //
    // 98, 99 and 100 were one of these each before they were collapsed into this.
    static type_roomAmbience: string = "101"
    // Server-initiated: open the NAME PROMPT over a specific entity so the player can name it --
    // a small field floating over the NPC, pre-filled with the name it already has. Sent when a
    // recruit is hired (the last beat of the role picker), which is the one moment it is offered.
    // Payload: { entityId, name } -- `name` is what the field starts with.
    static type_openNamePrompt: string = "102"
    // Server-initiated: open (or dismiss) the INVASION PICKER on a player whose ember run is over --
    // the camps they could rise in as one of the wave's attackers. Up to three, each a defending
    // player's name plus where their run is up to. Payload: { candidates: EmberInvasionCandidate[] };
    // an EMPTY list is a real answer ("no camp is open to the dead"), and null dismisses the picker.
    static type_updateInvasionOffer: string = "105"
    // Client-initiated: stop sending me world state, nobody is drawing it. Sent once the page has
    // been in the BACKGROUND for a couple of seconds. The client's frame loop is
    // requestAnimationFrame, which a hidden tab does not get, so an unsuspended stream piles up in
    // a queue nothing drains until the tab is killed for its memory -- taking the socket with it.
    // The socket itself stays open and keeps answering pings throughout. No payload.
    static type_suspendUpdates: string = "103"
    // Client-initiated: start sending again, and RESEND EVERYTHING. World state is a delta stream,
    // so a client that stopped listening cannot simply pick it back up -- every change it missed is
    // one the server already considers delivered (see Server.resyncClient). No payload.
    static type_resumeUpdates: string = "104"
    // Server-initiated, last thing before the socket is closed: this session is OVER, and here is
    // why. Sent when the same account logs in again somewhere else ("signedInElsewhere"), which
    // takes the account off this socket. It matters that the client is TOLD: a close on its own is
    // indistinguishable from the wifi blinking, and the client now redials one of those by itself
    // (connection_lifecycle.ts) -- which would take the account straight back off the tab that just
    // claimed it, with both sockets live and both driving the same avatar.
    // Payload: { reason }.
    static type_sessionEnded: string = "106"
    // Client-initiated: change an invited guest's mode. Payload: { entityId, playMode }.
    static type_setEmberPlayMode: string = "108"
    // Client-initiated: eject an invited guest into a fresh Ember room. Payload: { entityId }.
    static type_kickEmberPlayer: string = "107"
}
